import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Form, Table, Image } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import LinearProgress from "@mui/material/LinearProgress";

const AddAd = ({ showModal, handleClose, fetchAllAds }) => {
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [categoryOption, setCategoryOption] = useState([]);

    const [positionOption, setPositionOption] = useState([
        { label: "Left", value: "Left" },
        { label: "Right", value: "Right" },
        { label: "Top", value: "Top" },
        { label: "Bottom", value: "Bottom" }
    ]);
    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    useEffect(() => {
        getAllCategory();
    }, []);

    const getAllCategory = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllCategory",
        });

        const output = response.data;

        if (output.length > 0) {
            setCategoryOption(
                output.map((option) => ({
                    value: option.pk_cat_key,
                    label: option.cat_name,
                }))
            );
        }
    };

    const initialValues = {
        adv_title: "",
        adv_description: "",
        adv_img: null,
        created_by: sessionStorage.getItem("pk_user_key"),
        visibility: 1,
        fk_cat_key: "",
        adposition: "",
    };

    const basicSchema = Yup.object().shape({
        adv_title: Yup.string()
            .min(3, "Ad Title must be at least 3 characters.")
            .max(250, "Ad Title must be at most 250 characters.")
            .matches(/^[^\s].*[^\s]$/, "Notification Title should not have leading or trailing spaces.")
            .required("Ad Title is required.")
            .test("unique-link", "Ad Title is already existing in the database", async function (value) {
                if (!value) return true;
                const isAdvertisementTitleUnique = await checkAdvertisementTitle(value);
                return isAdvertisementTitleUnique;
            }),

        adv_description: Yup.string()
            .min(1, "Ad Description must be at least 1 character.")
            .max(250, "Ad Description must be at most 250 characters.")
            .matches(/^[^\s].*[^\s]$/, "Ad Description should not have leading or trailing spaces.")
            .required("Ad Description is required.")
            .strict(),
        adv_img: Yup.mixed()
            .required("Ad Banner is required.")
            .test("fileType", "Unsupported File Format", (value) => {
                // Define supported image formats
                const supportedFormats = ["image/jpeg", "image/png", "image/gif"];
                return value ? supportedFormats.includes(value.type) : false;
            })
            .test("fileSize", "File size must be less than 2MB", (value) => {
                const maxSize = 2 * 1024 * 1024; // 2MB in bytes
                return value ? value.size <= maxSize : false;
            }),

        fk_cat_key: Yup.string().required("Category is required."),
        adposition: Yup.string().required("Position is required."),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "addAdvertisement",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                resetFormFields(resetForm, setValues, initialValues);
                handleClose();
                fetchAllAds();
                toast.success("Added successfully!", {
                    autoClose: 3000,
                });
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;

    async function checkAdvertisementTitle(adv_title) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkAdvertisementTitle",
            adv_title: adv_title,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }
    return (
        <>
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Advertisement</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit} ref={formRef}>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Title <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="adv_title"
                                value={values.adv_title}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Ad Title"
                            />
                            {errors.adv_title && touched.adv_title && <p className="text-danger">{errors.adv_title}</p>}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Category <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Select
                                options={categoryOption}
                                id="fk_cat_key"
                                name="fk_cat_key"
                                value={categoryOption.filter((option) => values.fk_cat_key && values.fk_cat_key.includes(option.value))}
                                onChange={(selectedOptions) => {
                                    const event = {
                                        target: {
                                            name: "fk_cat_key",
                                            value: selectedOptions["value"], // Map to an array of selected values
                                        },
                                    };
                                    handleChange(event);
                                }}
                                onBlur={(event) => {
                                    handleBlur(event);
                                    setTouched({ ...touched, fk_cat_key: true });
                                }}
                            />

                            {errors.fk_cat_key && touched.fk_cat_key && <p className="text-danger">{errors.fk_cat_key}</p>}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Description <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                name="adv_description"
                                value={values.adv_description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Ad Description"
                            />
                            {errors.adv_description && touched.adv_description && <p className="text-danger">{errors.adv_description}</p>}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Banner <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Form.Control
                                type="file"
                                name="image"
                                onChange={(event) => {
                                    setFieldValue("adv_img", event.currentTarget.files[0]);
                                }}
                                onBlur={handleBlur}
                                accept="image/*"
                            />
                            {errors.adv_img && touched.adv_img && <p className="text-danger">{errors.adv_img}</p>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>
                                Ad Position <span className="text-danger">*</span>
                            </Form.Label>
                            <Select
                                options={positionOption}
                                id="adposition"
                                name="adposition"
                                value={positionOption.find(
                                    (option) => option.value === values.adposition
                                )}
                                onChange={(selectedOption) => {
                                    const event = {
                                        target: {
                                            name: "adposition",
                                            value: selectedOption.value,
                                        },
                                    };
                                    handleChange(event);
                                }}
                                onBlur={(event) => {
                                    handleBlur(event);
                                    setTouched({ ...touched, adposition: true });
                                }}
                            />

                            {errors.adposition && touched.adposition && (
                                <p className="text-danger">{errors.adposition}</p>
                            )}
                        </Form.Group>

                        <div className="mt-3">
                            <Button variant="dark" type="submit" disabled={isSubmitting}>
                                Add New Ad
                                {isSubmitting && <LinearProgress />}
                            </Button>
                            <Button variant="outline-secondary" className="ms-2" onClick={handleClose}>
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddAd;
